<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :append-to-body="true"
    title="تنظیمات گروهی"
    width="400px"
  >
    <el-form class="mt-4" @submit.native.prevent="submit">
      <div class="mb-4">
        <el-col :span="24" :xs="24" class="mb-4">
          <label class="font-9"> زمان نمونه گیری: </label>
          <el-input-number
            v-model="form.samplingTime"
            v-validate="'numeric'"
            size="small"
            class="mt-2"
            style="width: 100%;display: block"
            :min="0"
            data-vv-as="زمان نمونه گیری"
            placeholder="زمان نمونه گیری"
          >
          </el-input-number>
          <div style="clear: both"></div>
        </el-col>
        <el-col :span="11" :xs="24" class="mb-4" style="float: right">
          <label class="font-9"> وقفه جی پی اس (ثانیه): </label>
          <el-input-number
            v-model="form.gpsTimeout"
            v-validate="'numeric'"
            size="small"
            class="mt-2"
            style="width: 100%;display: block"
            :min="0"
            data-vv-as="وقفه جی پی اس (ثانیه):"
            placeholder="وقفه جی پی اس (ثانیه):"
          >
          </el-input-number>
          <div style="clear: both"></div>
        </el-col>
        <el-col :span="11" :xs="24" class="mb-4" style="float: left">
          <label class="font-9"> زمان وقفه دستگاه (ثانیه): </label>
          <el-input-number
            v-model="form.deviceTimeout"
            v-validate="'numeric'"
            size="small"
            class="mt-2"
            style="width: 100%;display: block"
            :min="0"
            data-vv-as="زمان وقفه دستگاه (ثانیه):"
            placeholder="زمان وقفه دستگاه (ثانیه):"
          >
          </el-input-number>
          <div style="clear: both"></div>
        </el-col>
      </div>
      <div class="text-center mt-5">
        <el-button type="primary" native-type="submit" :loading="loading">
          ثبت
        </el-button>
        <el-button
          :disabled="loading"
          @click="visible = false"
          v-text="'انصراف'"
        />
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import GroupSettingQuery from '@/graphql/settings/GroupSettings.gql'
export default {
  name: 'GroupSetting',
  props: {
    selection: { type: Array, default: () => [] },
    filters: { type: Array, default: () => [] },
    numbers: { type: Array, default: () => [] },
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      updatedFilters: [],
      settingIds: [],
      form: {
        deviceTimeout: 0,
        gpsTimeout: 0,
        samplingTime: 0
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set() {
        return this.$emit('update:show', false)
      }
    }
  },
  watch: {
    selection: {
      handler(IdArray) {
        this.settingIds = []
        IdArray.forEach(item => {
          this.settingIds.push(item.id)
        })
        this.settingIds = [...new Set(this.settingIds)]
      }
    },
    filters: {
      handler(val) {
        this.updatedFilters = val
      }
    }
  },
  methods: {
    submit() {
      this.$validate().then(() => {
        let filter = {
          filters:
            this.selection.length > 0
              ? [{ field: 'id', op: '=', value: `[${this.settingIds}]` }]
              : [...this.updatedFilters]
        }

        let setting = this.$clone(this.form)

        setting.samplingTime *= 60
        Object.keys(setting).forEach(key => {
          if (setting[key] === 0) delete setting[key]
        })

        this.apollo
          .mutate({
            query: GroupSettingQuery,
            variables: {
              filter: filter,
              setting: setting
            }
          })
          .then(() => {
            this.$emit('update')
            this.$message.success('تنظیمات گروهی اعمال شد')
            this.visible = false
            for (let k in this.form) {
              this.form[k] = ''
            }
          })
      })
    }
  }
}
</script>
